import { Pipe, PipeTransform } from '@angular/core';
import { PaymentData } from '../interfaces/payment/payment-data';

@Pipe({
  name: 'subPaymentItems'
})
export class SubPaymentItemsPipe implements PipeTransform {

  transform(paymentType: PaymentData[], paymentMethod: string): PaymentData[] | [] {
    if (paymentType.filter(item => item.paymentMethod === paymentMethod).length > 0) {
      return paymentType.filter(item => item.paymentMethod === paymentMethod);
    }
    return [];
  }

}
